import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import TicketForm from './Components/TicketForm';


const Ticketing = () => {


  return (
    <div className=''>

      <Header />
      <TicketForm/>
      <Footer />
    
  </div>
  )
};

export default Ticketing;